import Api from "./Api";

export const SaveBanner = async (payload) =>
  Api().post(`/banner/save`, payload);

export const getBanners = async () =>
  Api().get(`/banner/get`);